import { render, staticRenderFns } from "./listReceitas.vue?vue&type=template&id=6b48ab96&scoped=true"
import script from "./listReceitas.vue?vue&type=script&lang=js"
export * from "./listReceitas.vue?vue&type=script&lang=js"
import style0 from "./listReceitas.vue?vue&type=style&index=0&id=6b48ab96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48ab96",
  null
  
)

export default component.exports